// as per https://dev.to/lenmorld/prop-drilling-react-context-and-higher-order-component-hoc-40m9
import React from "react"

import { RecombeeContextConsumer } from "./RecombeeContext"

const withRecombee = Component => {
  class ComponentWithRecombeeInfo extends React.Component {
    render() {
      return (
        <RecombeeContextConsumer>
          {recombee => <Component {...this.props} recombee={recombee} />}
        </RecombeeContextConsumer>
      )
    }
  }

  return ComponentWithRecombeeInfo
}

export default withRecombee
